import { aFechaLocal } from './fechas';

type NocheParaProgreso = {
  fecha: string;
  movimientos: readonly { id: number; jugados: number; ganados: number; antes: number; despues: number }[];
};
type LogroParaProgreso = { logro_id: string; contexto?: string; origen?: string; partido_id: number | null; obtenido_en: number };

/** Mismo cambio visible que la placa: diferencia entre niveles mostrados. */
export function tuNoche(noche: NocheParaProgreso, jugadorId: number, logros: readonly LogroParaProgreso[]) {
  const movimiento = noche.movimientos.find(m => m.id === jugadorId);
  if (!movimiento) return null;
  const obtenidos = new Map<string, number>();
  for (const logro of logros) {
    // Los premios de mes/año no pertenecen a una noche, aunque coincida la fecha.
    const manualDeLaNoche = logro.origen === 'manual' && logro.contexto === noche.fecha;
    if (!manualDeLaNoche && (logro.partido_id === null || aFechaLocal(new Date(logro.obtenido_en * 1000)) !== noche.fecha)) continue;
    obtenidos.set(logro.logro_id, (obtenidos.get(logro.logro_id) ?? 0) + 1);
  }
  return {
    fecha: noche.fecha,
    jugados: movimiento.jugados,
    ganados: movimiento.ganados,
    perdidos: movimiento.jugados - movimiento.ganados,
    antes: Math.round(movimiento.antes),
    despues: Math.round(movimiento.despues),
    cambio: Math.round(movimiento.despues) - Math.round(movimiento.antes),
    logros: [...obtenidos].map(([id, veces]) => ({ id, veces })),
  };
}
